import React from "react";
import "../../../AllComponentCSS.css";

function JS_sort() {
  return (
    <div className="tutorial-page">
      <h1>JS sort</h1>
      <p>This page will cover the sort topic in detail.</p>
    </div>
  );
}

export default JS_sort;
